const homepage = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default homepage;
